export const GATEWAYS_RESET_STATE = 'GATEWAYS_RESET_STATE';
export const GATEWAYS_CURRENT_ITEM = 'GATEWAYS_CURRENT_ITEM';

export const GATEWAYS_REQUEST_LOADING = 'GATEWAYS_REQUEST_LOADING';
export const GATEWAYS_REQUEST_SUCCESS = 'GATEWAYS_REQUEST_SUCCESS';
export const GATEWAYS_REQUEST_FAILED = 'GATEWAYS_REQUEST_FAILED';

export const GATEWAYS_CURRENT_ACTION = 'GATEWAYS_CURRENT_ACTION';
export const GATEWAYS_RESET_ACTION = 'GATEWAYS_RESET_ACTION';